<template>
  <div>
    <div class="mui-card">
      <div class="mui-card-header">
        {{ list.building.name }}
      </div>
      <div class="mui-card-content">
        <div class="mui-card-content-inner">
         {{ list.building.address }}
          <br>
          {{ list.building.buildingtype_text }}
          <div class="mui-card-content-inner-img">
            <img :src="item.image" alt="" v-for="(item, index) in list.devicetypelist" :key="index">
          </div>
        </div>
      </div>
      <div class="mui-card-footer">
        采集人：
        <div class="contribute">
          <span v-for="(item, index) in list.currentlist" :key="index">
            <span v-if="index != 0">、</span>{{ item.username }}
          </span>
        </div>
        <span class="mui-icon mui-icon-plus mui-media-body-icon" v-if="list.isjoin - 0 === 0"
              @click.prevent="checkedBuild(list.id)" ref="checkedBuildValue"></span>
        <span class="mui-icon mui-icon-minus mui-media-body-icon" v-else
              @click.prevent="checkedBuild(list.id)" ref="checkedBuildValue"></span>
      </div>
    </div>
    <div class="mui-card">
      <ul class="mui-table-view">
        <li class="mui-table-view-cell mui-media" v-for="(item, index) in list.building.childbuildinglist" :key="index">
          <a class="mui-navigate-right">
            <div class="mui-media-body">
              <div class="mui-media-body-left">
                {{  item.name }}
              </div>
              <div class="mui-media-body-right">
               <span class="mui-progressbar mui-progressbar-danger" data-progress="50">
                  {{ item.childcomplaterate }}%
                  <span :style="'transform: translate3d(-' + (100 - item.childcomplaterate) + '%, 0px, 0px); opacity: 0.6'"></span>
                </span>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="mui-card" id="add-button">
      <button type="button" class="mui-btn mui-btn-primary " style="color: #fff;" v-if="showCard" @click="isShowPopup">开始采集</button>
    </div>
    <mt-popup v-model="showPopup" position="bottom" type="ios" pop-transition="popup-fade" title="请选择要采集的建筑" v-show="showPopup">
      <div class="mui-card" style="width: 100%">
        <div class="mui-card-header">
          请选择要采集的建筑
        </div>
        <ul class="mui-table-view">
          <li class="mui-table-view-cell" v-for="(item, index) in list.building.childbuildinglist" :key="index">
            <router-link :to="'/Build/buildDetail/' + task_id + '/' + item.id" class="mui-navigate-right">
              {{  item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import {MessageBox, Toast} from 'mint-ui'
export default {
  name: 'SecondBuild',
  data () {
    return {
      showCard: false,
      title: '任务详情',
      task_id: this.$route.params.taskId,
      checkedBuildValue: false,
      showPopup: false,
      list: {
        'id': 8,
        'name': '测试',
        'building_id': 1271,
        'desc': '',
        'starttime': '2021-03-17 09:38:58',
        'endtime': '2021-03-17 09:38:58',
        'status': 1,
        'deletetime': null,
        'weigh': 8,
        'max': 1,
        'admin_id': 9,
        'building': {
          'name': '测试一级建筑物2',
          'province': '江苏',
          'city': '苏州',
          'area': '虎丘',
          'address': '32323',
          'lng': '3232',
          'lat': '32323',
          'levellist_text': 'Levellist 1',
          'buildingtype_text': '会展中心/博览中心/科技馆/艺术馆',
          'childbuildinglist': [
            {
              'name': '测试二级建筑物2',
              'buildingtype_id': 16,
              'id': 1272,
              'levellist_text': '',
              'buildingtype_text': '会展中心/博览中心/科技馆/艺术馆',
              'childbuildinglist': [],
              'buildingimg': null,
              'childcomplaterate': 25
            }
          ],
          'buildingimg': '/uploads/20210310/eb2f4ecc180a5e05fc085b3bc8ce0e6d.jpg'
        },
        'status_text': 'Status 1',
        'current': 1,
        'devicetypelist': [
          {
            'id': 8,
            'name': '无障碍电梯',
            'image': 'https://onbotics-map.oss-cn-shanghai.aliyuncs.com/public/a9e2754f208d7612321c8fc0a2d561c4.png'
          }
        ],
        'currentlist': [
          {
            'username': '采集员2'
          }
        ],
        'completerate': 25
      }
    }
  },
  created () {
    setTimeout(() => {
      this.showCard = true
    }, 530)
    this.getChildBuildingInfo()
    this.$emit('getTitle', this.title)
  },
  methods: {
    checkedBuild (taskIndex) {
      if (this.list.isjoin === '0') {
        MessageBox({
          title: '确认操作',
          message: '你确定选取' + this.list.building.name + '区域任务吗？该区域包含' + this.list.building.childbuildinglist.length + '座建筑',
          showCancelButton: true
        }).then(action => {
          if (action === 'confirm') {
            this.$http.get('api/gather/joinTask?task_id=' + this.list.id)
              .then((data) => {
                if (data.body.code === 1) {
                  this.list.isjoin = '1'
                  this.list.currentlist.push({'username': '前端采集员'})
                  Toast('已加入该任务')
                }
              })
          } else {
            this.list.isjoin = '0'
          }
        }).catch(error => {
          if (error === 'cancel') {
            this.list.isjoin = '0'
          }
        })
      } else {
        MessageBox({
          title: '确认操作',
          message: '你确定放弃' + this.list.building.name + '区域任务吗？该区域包含' + this.list.building.childbuildinglist.length + '座建筑',
          showCancelButton: true
        }).then(action => {
          if (action === 'confirm') {
            this.$http.get('api/gather/exitTask?task_id=' + this.list.id)
              .then((data) => {
                if (data.body.code === 1) {
                  this.list.isjoin = '0'
                  for (let i = 0; i < this.list.currentlist.length; i++) {
                    if (this.list.currentlist[i].username === '前端采集员') {
                      this.list.currentlist.splice(i, 1)
                    }
                  }
                  Toast('已退出该任务')
                }
              })
          } else {
            this.taskList[taskIndex].isjoin = '1'
          }
        }).catch(error => {
          if (error === 'cancel') {
            this.taskList[taskIndex].isjoin = '1'
          }
        })
      }
    },
    getChildBuildingInfo () {
      this.$http.get('api/gather/getTaskInfo?id=' + this.task_id)
        .then(function (data) {
          if (data.body.code === 1) {
            this.list = data.body.data.list
          } else {
            Toast('此任务不存在')
          }
        })
    },
    isShowPopup () {
      if (this.list.isjoin - 0 === 0) {
        Toast('请先加入该任务')
        return false
      } else {
        this.showPopup = !this.showPopup
      }
    }
  }
}
</script>
<style scoped lang="scss">
.mui-card-footer img{
  width: 15%;
}

.mint-swipe{
  height:178.5px;
  .mint-swipe-item{
    img{
      width: 100%;
    }
  }
}

.mui-table-view{
  .mui-table-view-cell{
    .mui-navigate-right{
      .mui-media-body{
        .mui-media-body-left{
          width: 60%;
          float: left;
          font-size: 16px;
          line-height: 26px;
          padding-top: 5px;
        }
        .mui-media-body-right{
          width:35%;
          display: inline-block;
          padding-top: 5px;
          .mui-progressbar{
            height: 26px;
            display: inline-block;
            float: left;
            border-radius: 5%;
            text-align: center;
            line-height: 26px;
          }
        }
      }
    }
  }
}

.mui-table-view-chevron .mui-table-view-cell {
  padding-right: 57px;
}

#add-button{
  position: fixed;
  margin: 10px;
  width: 95%;
  bottom: 20px;
  .mui-btn{
    width: 100%;
  }
}

.mui-card-header{
  display: block;
  text-align: center;
}

.contribute{
  width: 75%;
  overflow:hidden;
  text-overflow:ellipsis;
  display: inline-block;
}
.mui-card-content{
  .mui-card-content-inner{
    .mui-card-content-inner-img{
      width: 100%;
      padding-top: 10px;
      img{
        display: inline-block;
        padding-left: 5px;
        width: 25px;
      }
    }
  }
}

.mint-popup, .mint-popup-bottom{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Build/SecondBuild.vue